import {Component, ElementRef, Input, OnChanges, OnInit} from "@angular/core";
import {ValidationError, ValidationErrorRow} from "./validation-error";
import {MultiValidationError} from "./multi-validation-error";
import {MultiError} from "./multi-error";

const validatableTags = ["INPUT", "SELECT", "TEXTAREA", "DATEPICKER"];

@Component({
  selector: "validation-error-display",
  templateUrl: "./validation-error-display.template.pug",
})
export class ValidationErrorDisplayComponent implements OnChanges, OnInit {
  private validationTarget: HTMLElement;

  validationErrorRows: ValidationErrorRow[] = [];

  @Input()
  index: string;

  @Input()
  field: string;

  @Input()
  error: Error;

  constructor(private el: ElementRef) {}

  private updateValidationTarget() {
    const children = Array.from(this.el.nativeElement.parentElement.children) as HTMLElement[];

    this.validationTarget = undefined;

    this.validationTarget = children.filter(it => it.classList.contains("validation-target"))[0];
    if (this.validationTarget) return;

    this.validationTarget = children.filter(it => validatableTags.includes(it.tagName))[0];
  }

  private setValidationState(valid: boolean) {
    if (!this.validationTarget) return;

    const hasInvalidFlag = this.validationTarget.classList.contains("is-invalid");

    if (valid && hasInvalidFlag) {
      this.validationTarget.classList.remove("is-invalid");
    } else if (!valid && !hasInvalidFlag) {
      this.validationTarget.classList.add("is-invalid");
    }
  }

  ngOnInit(): void {
    (this.el.nativeElement as HTMLElement).classList.add("invalid-feedback");

    this.updateValidationTarget();
  }

  ngOnChanges(): void {
    let error: Error = this.error;

    if (error instanceof MultiError) error = (error as MultiError).errors[0] as Error;

    let validationErrorRows: ValidationErrorRow[];

    if (error instanceof MultiValidationError) {
      const row = (error as MultiValidationError).validationErrorRows.find(it => it.index === this.index);
      if (row) validationErrorRows = row.error;
    } else if (error instanceof ValidationError) {
      validationErrorRows = (error as ValidationError).validationErrors;
    }

    if (validationErrorRows && validationErrorRows.length) {
      this.validationErrorRows = validationErrorRows.filter(it => it.field === this.field);
    } else {
      this.validationErrorRows = [];
    }

    this.setValidationState(this.validationErrorRows.length === 0);
  }
}
